import React from 'react';
const placeholderImg = 'https://digitalearnpro.com/wp-content/uploads/2025/09/20250930_1424_Espacio-para-tu-Imagen_simple_compose_01k6dtcpvgec9s48a98jsekbnr.png';
export function GuaranteeSection() {
  return <section className="bg-cream pt-[40px] pb-[40px] px-[15px] relative" data-id="element-109">
      <div className="max-w-[500px] mx-auto px-[15px] text-center" data-id="element-110">
        <h2 className="text-[26px] text-center mb-6 leading-[1.2] font-bold text-black heading-underline" data-id="element-111">
          Compra 100% Sin Riesgos
        </h2>
        <p className="text-[15px] leading-[1.6] text-dark-gray text-left" data-id="element-112">
          Estamos tan seguros de que nuestro plan te funcionará, que te
          ofrecemos una garantía de satisfacción total. Si en los próximos{' '}
          <strong data-id="element-113">7 días</strong> no estás feliz con tus resultados, nos envías
          un simple email y te devolvemos el <strong data-id="element-114">100% de tu dinero</strong>.{' '}
          <strong data-id="element-115">Sin preguntas.</strong>
        </p>

        <div className="flex items-center justify-center gap-4 bg-white rounded-lg p-4 my-6 mx-auto shadow-[0_4px_10px_rgba(0,0,0,0.05)] max-w-full border border-[#eee]" data-id="element-116">
          <img className="w-[50px] h-auto rounded-full" alt="Garantía 30 días sin riesgo" src="https://cdn.magicpatterns.com/uploads/dwdot51tBU3bBRViuVS1hJ/Gemini_Generated_Image_sz2uksz2uksz2uks.jpg" data-id="element-117" />
          <div className="text-left" data-id="element-118">
            <h3 className="text-[15px] text-success mb-[3px] font-bold" data-id="element-119">
              Garantía de Satisfacción ️
            </h3>
            <p className="text-[12px] text-dark-gray m-0" data-id="element-120">
              7 días para probar sin riesgo alguno
            </p>
          </div>
        </div>
      </div>
    </section>;
}